import { listOrganizationsWithVM } from '@src/utils/admin';
import { ACTION, type Organization } from '@talos/kyoko';
import { useEffect, useState } from 'react';
import { useRoleAuth } from './useRoleAuth';

interface UseOrganizationsWithVMResult {
  organizations: Organization[] | undefined;
  isLoading: boolean;
}

export function useOrganizationsWithVM(): UseOrganizationsWithVMResult {
  const [organizations, setOrganizations] = useState<Organization[] | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthorized } = useRoleAuth();

  useEffect(() => {
    if (!isAuthorized(ACTION.USE_ORGANIZATION)) {
      return;
    }

    setIsLoading(true);
    listOrganizationsWithVM()
      .then(setOrganizations)
      .catch(() => {
        setOrganizations([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isAuthorized]);

  return { organizations, isLoading };
}
